import { createUploadLink } from 'apollo-upload-client';
import { ApolloLink } from '@apollo/client';
import config from '@src/config/config';

export const uploadLink: ApolloLink = createUploadLink({
  credentials: 'include',
  uri: config.graphqlApi,
});
